import React from 'react'
import PropTypes from 'prop-types'
import { useConnect } from 'sb-redux-hook'
import { constants, snowplow } from 'common/helpers'

import LinkWithIcon from 'components/ui/LinkWithIcon/LinkWithIcon'

import s from './FooterNav.scss'


const FooterNav = ({ items, ariaLabel }) => {
  const { userLoggedIn } = useConnect({
    userLoggedIn: 'models.me.isLoggedIn',
  })

  return (
    <nav className={s.nav} aria-label={ariaLabel}>
      <ul>
        {
          items.map(({ title, icon, to, toOLD, redirect, onClick }, index) => (
            <li key={index}>
              <LinkWithIcon
                className={s.link}
                customColor
                onClick={(event) => {
                  snowplow.track(constants.snowplowEvents.footerLinkClick, {
                    title: typeof title === 'object' ? title.en : title,
                    link: to || toOLD || redirect,
                    userLoggedIn: userLoggedIn ? 'yes' : 'no',
                  })

                  if (typeof onClick === 'function') {
                    onClick(event)
                  }
                }}
                {...{ title, icon, to, toOLD, redirect }}
              />
            </li>
          ))
        }
      </ul>
    </nav>
  )
}

FooterNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.object.isRequired,
    to: PropTypes.string,
    toOLD: PropTypes.string,
  })),
}


export default FooterNav
